export default {
      id: "quote-open-usage",
      viewBox: "0 0 45 36",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#quote-open-usage",
      toString: function () {
        return this.url;
      }
    }